/** Skeleton der Support-Seite (Header + Karten-Grid), statt Spinner. */
export function SupportSkeleton() {
  return (
    <div className="flex-1 w-full max-w-[480px] mx-auto px-5 pt-8" role="status" aria-label="Lädt">
      <div className="skeleton h-9 w-3/4 rounded-lg mb-2" />
      <div className="skeleton h-9 w-1/2 rounded-lg mb-6" />
      <div className="skeleton h-3 w-24 rounded mb-2" />
      <div className="skeleton h-8 w-40 rounded-[11px] mb-10" />
      <div className="grid grid-cols-2 gap-x-[22px] gap-y-[18px] -mx-1">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skeleton h-[150px] rounded-[20px]" />
        ))}
      </div>
      <span className="sr-only">Automat wird geladen…</span>
    </div>
  )
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-svh" role="status" aria-label="Lädt">
      <div className="w-8 h-8 rounded-full border-2 border-[var(--color-text)] border-t-transparent animate-spin" />
    </div>
  )
}
